<template>
  <div id="app">
    <b-container id="menuContainer" fluid>
      <navBar/>
      <sideBar/>
    </b-container>
    <div id="mainContainer">
      <b-container fluid>
        <router-view/>
      </b-container>
    </div>
  </div>
</template>

<script>
import navBar from './components/menu/navBar'
import sideBar from './components/menu/sideBar'

export default {
  name: 'app',
  components: {
    navBar,
    sideBar
  },
  metaInfo:{
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'AK Wilno',
    // all titles will be injected into this template
    titleTemplate: '%s | AK Wilno',
    meta:[
      {name: 'keywords', content: 'AK, Wilno, Janusz, Bohdanowicz, ostra, brama, czortek, ośrodek, karta, historia, wielńszczyzna, oddziay, brygady, tablice, epitafijne, środowiska, kombatanckie, Gdańsk, Warszawa, Państwo, Podziemne, Vue, Javascript, HTML, Dawid Bonik'},
      {name: 'author', content: 'Dawid Bonik'},
      {name: 'og:type', content: 'website' },
      {name: 'og:site_name', content: 'AK Wilno' },
      {name: 'og:locale', content: 'pl_PL' },
      {name: 'article:author', content: 'Dawid Bonik' },
      {name: 'twitter:card', content: 'summary' },
      {name: 'twitter:site', content: '@osrodekkarta' },
      {name: 'twitter:creator', content: '@Boni0' }
    ],
    link:[
      {rel: 'icon', href: '/static/main/site_ico.ico'}
    ]
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans');
  p{
    font-family: 'Noto Sans', sans-serif;
    text-align: justify;
  }

  .display-3{
    word-wrap: break-word;
  }

  @media screen and (max-width: 768px){
    .carousel-caption{
      display: none !important;
    }
  }

  .router-link-list{
      color: black;
  }

  .btn-white-space {
    white-space: normal;
  }

  .carousel .carousel-caption,
  .carousel .carousel-control-prev-icon,
  .carousel .carousel-control-next-icon{
    background-color: rgba(0, 0, 0, 0.4)
  }
</style>

<style scoped>
  #mainContainer{
    margin-bottom: 5em;
  }
  @media screen and (min-width: 992px){
    #mainContainer{
      margin-left: 260px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue